import { ChevronRight } from "lucide-react";

import { HorizontalFlexbox } from "@src/shared/components/layout/Flexbox";
import { Button } from "@src/shared/components/ui/button";

export function PaginationControls({
  hasNextPage,
  hasPrevPage,
  onNext,
  onPrevious,
}: {
  hasNextPage: boolean;
  hasPrevPage: boolean;
  onNext: () => void;
  onPrevious: () => void;
}) {
  if (!hasPrevPage && !hasNextPage) return null;

  return (
    <HorizontalFlexbox
      alignItems="center"
      justifyContent="flex-end"
      gap="xs"
      className="mt-4"
    >
      <Button
        type="button"
        variant="outline"
        size="sm"
        disabled={!hasPrevPage}
        onClick={onPrevious}
      >
        Previous
      </Button>
      <Button
        type="button"
        variant="outline"
        size="sm"
        disabled={!hasNextPage}
        onClick={onNext}
      >
        Next
        <ChevronRight className="size-3.5" aria-hidden="true" />
      </Button>
    </HorizontalFlexbox>
  );
}
